<template>
  <div class="synthese">

    <v-module title="Information">
      <div class="synthese-exploitation ct-flex-row">
        <div class="item-flex-full"><span class="libelle">Objectif</span><span class="value money">{{ data.objectif }}</span></div>
        <div class="item-flex-full"><span class="libelle">Dernier appel moteur</span><span class="value">{{ currentSimulation.simulation.updated_at | formatDateHeure }}</span></div>
        <div class="item-flex-full"><span class="libelle"><abbr title="Droit paiement de base">DPB</abbr></span><span class="value moneysurface">{{ data.dpb }}</span></div>
        <div class="item-flex-full"><span class="value">{{ data.nom_commune }} {{data.code_postal}} ({{ data.nom_departement }})</span></div>
      </div>
      <div class="synthese-exploitation ct-flex-row" v-if="currentSimulation.simulation.fichier_simu_clim">
        <div class="item-flex-full"><span class="libelle">Simulation climatique (fichier / année)</span>
          <span class="value">{{ currentSimulation.simulation.fichier_simu_clim }} / {{ currentSimulation.simulation.annee_simu_clim }}</span>
        </div>
      </div>
    </v-module>

    <div class="ilot">
      <v-module v-for="ilot in ilots" :key="ilot.id_ilot" :title="ilot.nom_ilot + ' - ' + ilot.sau + ' ha'">
          <div class="ct-flex-row">
            <ul class="item-flex-full">
              <li v-for="sol in ilot.sols" :key='sol.code'>
                <abbr :title="sol.code + ' ' + sol.nom_arvalis">{{ sol.nom }}</abbr> <span class="secondaire">(<span class="surface">{{sol.surface }}</span> / ru {{ sol.ru }} / rfu {{sol.rfu }})</span>
              </li>
            </ul>
            <div v-if="ilot.non_irrigue !== true" class="item-flex-full">
              <div>{{ilot.nombre_materiel}} {{ ilot.nom_materiel }} ( {{ ilot.debit_materiel }}m3/h * {{ ilot.utilisation_materiel}} h = {{ ilot.nombre_materiel * ilot.debit_materiel * ilot.utilisation_materiel}} m3)</div>
              <div><span class="libelle">Redevance agent bassin</span> <span class="value centimevolume">{{ ilot.prix_eau }}</span></div>
              <div><span class="libelle">Energie pompage</span> <span class="value centimevolume">{{ ilot.cout }}</span></div>
              <div><span class="libelle">Charges opérationnelle d'irrigation</span> <span class="value centimevolume">{{ ilot.prix_irrigation }}</span></div>
              <div><span class="libelle">Charges fixes d'irrigations</span> <span class="value moneysurface">{{ ilot.charge_fixe_ilot }}</span></div>
              <div><span class="libelle">Volume</span> <span class="value volume">{{ ilot.volume_irrigation }}</span></div>
            </div>
          </div>
      </v-module>
    </div>

    <div class="culture">
      <v-module v-for="culture in cultures" :key="culture.id_culture" :title=" culture.nom_culture  + '  ' + culture.nom_variete">
          <div class="ct-flex-row">
            <!-- infos -->
            <div class="item-flex-full">
              <div><span class="libelle">Date semis</span> <span class="value">{{ culture.date_semis }}</span></div>
              <div><span class="libelle">Culture précédente</span> <span class="value">{{ culture.nom_precedent }}</span></div>
              <div><span class="libelle">Charges fixes</span> <span class="value moneysurface">{{ culture.charge_fixe }}</span></div>
              <div><span class="libelle">Charges opérationelles</span> <span class="value moneysurface">{{ culture.charge_fixe_irrigation }}</span></div>
              <div v-if="culture.prix_par_tonne"><span class="libelle">Prix</span> <span class="value moneytonne">{{ culture.prix_par_tonne }}</span></div>
              <div v-if="culture.temps_travail"><span class="libelle">Temps de traction hors irrig</span> <span class="value heuresurface">{{ culture.temps_travail }}</span></div>
            </div>
            <!-- sols -->
            <ul class="item-flex-full" v-if="culture.sols">
              <li v-for="sol in culture.sols" :key='sol.code'>
                <abbr :title="sol.code + ' ' + sol.nom_arvalis">{{ sol.nom }}</abbr> <span class="secondaire">({{sol.rendement }} q/ha)</span>
              </li>
            </ul>
            <!-- cipan -->
            <div class="item-flex-full" v-if="culture.date_semis_cipan || culture.date_levee_cipan || culture.date_destruction_cipan || culture.note_dev_cipan">
              <div v-if="culture.date_semis_cipan"><span class="libelle">Semis cipan</span> <span class="value">{{ culture.date_semis_cipan }}</span></div>
              <div v-if="culture.date_levee_cipan"><span class="libelle">Levée cipan</span> <span class="value">{{ culture.date_levee_cipan }}</span></div>
              <div v-if="culture.date_destruction_cipan"><span class="libelle">Destruction cipan</span> <span class="value">{{ culture.date_destruction_cipan }}</span></div>
              <div v-if="culture.note_dev_cipan"><span class="libelle">Semis cipan</span> <span class="value">{{ culture.note_dev_cipan }}</span></div>
            </div>
            <!-- stades -->
            <div class="item-flex-full" v-if="culture.stades || culture.nom_stade_fin">
              <span class="libelle">Stades</span>
              <ul>
                <li v-for="stade in culture.stades" :key="stade.nom">
                  {{ stade.nom }} : {{ stade.dose }}mm / {{ stade.periode }} j
                </li>
                <li v-if="culture.nom_stade_fin"> {{ culture.nom_stade_fin }}</li>
              </ul>
            </div>
          </div>
      </v-module>
    </div>
  </div>
</template>

<script>
export default {
  name: 'synthese-resultat',
  props: {
    data: {
      type: Object
    }
  },

  computed: {
    currentSimulation () {
      return this.$store.state.simulation.currentSimulation || {}
    },
    ilots () {
      return this.data.ilots.filter(i => i.id_ilot)
    },
    cultures () {
      return this.data.cultures.filter(c => c.id_culture)
    }
  }
}
</script>

<style lang="scss">
.synthese {

  ul {
    padding-left: 1em;
    list-style: none;
  }
}
</style>
